import {
  inject,
  InjectionToken,
  LOCALE_ID,
  makeEnvironmentProviders
} from '@angular/core';
import {
  COUNTRY_OPTIONS,
  COUNTRY_OPTIONS_DE,
  NameValue
} from '@ui/shared/model';

export const COUNTRIES = new InjectionToken<NameValue[]>('COUNTRIES');

export function provideCountries() {
  return makeEnvironmentProviders([
    {
      provide: COUNTRIES,
      useFactory: () => {
        const local = inject(LOCALE_ID);
        return local === 'de' ? COUNTRY_OPTIONS_DE : COUNTRY_OPTIONS;
      }
    }
  ]);
}
